import React from 'react'

export type RsmLogoProps = {
  width?: number
  titleDescription?: string
}

const NewRsmLogo = ({
  width = 105,
  titleDescription = 'Rsm Logo',
}: RsmLogoProps) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 92.33 27.09"
    width={width}
    role="img">
    <title>{titleDescription}</title>
    <defs>
      <mask
        id="mask"
        x="78.49"
        y=".34"
        width="13.84"
        height="21.56"
        maskUnits="userSpaceOnUse">
        <g id="mask0_24622_41064" data-name="mask0 24622 41064">
          <path
            d="m78.49.34h13.84v21.56h-13.84V.34Z"
            fill="#fff"
            fillRule="evenodd"
            strokeWidth="0"
          />
        </g>
      </mask>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <path
          d="m47.82,7.28c0-2.34-.82-4.22-2.36-5.42-1.59-1.23-3.44-1.52-6.18-1.52h-8.34v21.56h4.52V4.22h3.98c1.13,0,1.94.14,2.48.45.79.45,1.26,1.29,1.26,2.61,0,2.25-1.43,3.04-3.3,3.04h-3.01v3.9h1.8l4.7,7.67h5.22l-5.22-8.4c3.04-.86,4.45-3.31,4.45-6.22Z"
          fill="#fff"
          fillRule="evenodd"
          strokeWidth="0"
        />
        <path
          d="m61.52,9.69c-3.21-1.07-6.82-1.2-6.82-3.56,0-1.52,1.43-2.22,3.47-2.22s3.77.18,6.77.95V.95c-2.57-.7-4.45-.95-6.88-.95-4.4,0-8.13,1.7-8.13,6.04,0,3.43,1.75,5.15,5.22,6.31,3.09,1.02,6.58,1.23,6.58,3.54,0,1.73-1.73,2.45-4.24,2.45s-3.96-.18-7.07-1v3.93c2.6.75,4.78.96,7.31.96,5.52,0,8.76-2.34,8.76-6.67,0-3.43-2.32-4.97-4.96-5.86Z"
          fill="#fff"
          fillRule="evenodd"
          strokeWidth="0"
        />
        <g mask="url(#mask)">
          <path
            d="m86.43.34l-7.94,21.56h4.31l5.03-13.71h.07v13.71h4.43V.34h-5.9Z"
            fill="#fff"
            fillRule="evenodd"
            strokeWidth="0"
          />
        </g>
        <path
          d="m80.03,13.76L74.87.34h-6v21.56h4.38v-13.71h.07l4.48,11.63,2.23-6.07Z"
          fill="#fff"
          fillRule="evenodd"
          strokeWidth="0"
        />
        <path
          d="m1.98,22.47H0v-11h1.98v1.54h.04c1.12-1.17,2.31-1.76,3.59-1.75,1.58,0,2.59.64,3.01,1.91,1.2-1.27,2.51-1.91,3.92-1.91,1.09,0,1.91.31,2.47.93.56.62.83,1.52.83,2.69v7.59h-1.98v-7.15c0-1.61-.73-2.42-2.2-2.42-.78,0-1.71.43-2.79,1.3.03.47.04.88.04,1.21v7.06h-1.98v-7.24c-.03-1.55-.76-2.33-2.2-2.33-.74,0-1.66.42-2.75,1.26v8.31Zm17.05,4.62c-.53,0-1.08-.05-1.64-.15l.19-1.65c.39.07.73.11,1.01.11,1.15,0,2.06-.9,2.75-2.71l-4.29-11.21h2.22l3.19,9h.04l2.99-9h2.12l-4.14,11.66c-.49,1.43-1.08,2.44-1.77,3.05-.69.61-1.59.91-2.67.91Z"
          fill="#fff"
          strokeWidth="0"
        />
      </g>
    </g>
  </svg>
)

export default NewRsmLogo
